import { MessageCircle, Linkedin, Instagram, Facebook } from "lucide-react";

const SOCIAL = {
    whatsapp: `https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER || "917836874807"}`,
    linkedin: process.env.REACT_APP_LINKEDIN_URL || "#",
    instagram: process.env.REACT_APP_INSTAGRAM_URL || "#",
    facebook: process.env.REACT_APP_FACEBOOK_URL || "#",
};

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050507]">
            <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-16">
                <div className="grid md:grid-cols-4 gap-10">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-3">
                            <img src="/lead-krafts-icon.png" alt="Lead Krafts" className="h-8 w-8 object-contain" />
                            <span className="font-serif-display text-xl">
                                Lead <span className="text-[#D4AF37] italic">Krafts</span>
                            </span>
                        </div>
                        <p className="mt-6 text-sm text-white/60 max-w-sm leading-relaxed">
                            Lead Krafts is a real-estate demand generation & lead qualification partner for
                            developers, brokers and channel partners across India.
                        </p>
                        <div className="mt-6 flex items-center gap-3" data-testid="footer-social">
                            <a href={SOCIAL.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="h-9 w-9 grid place-items-center border border-white/10 text-white/70 hover:text-[#25D366] hover:border-[#25D366] transition-colors"><MessageCircle size={16} strokeWidth={1.5} /></a>
                            <a href={SOCIAL.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="h-9 w-9 grid place-items-center border border-white/10 text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors"><Linkedin size={16} strokeWidth={1.5} /></a>
                            <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-9 w-9 grid place-items-center border border-white/10 text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors"><Instagram size={16} strokeWidth={1.5} /></a>
                            <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-9 w-9 grid place-items-center border border-white/10 text-white/70 hover:text-[#D4AF37] hover:border-[#D4AF37] transition-colors"><Facebook size={16} strokeWidth={1.5} /></a>
                        </div>
                    </div>
                    <div>
                        <div className="overline mb-4">Company</div>
                        <ul className="space-y-2 text-sm text-white/60">
                            <li><a href="#calculator" className="hover:text-[#D4AF37]">CPL Calculator</a></li>
                            <li><a href="#results" className="hover:text-[#D4AF37]">Verified Results</a></li>
                            <li><a href="#how" className="hover:text-[#D4AF37]">How it works</a></li>
                            <li><a href="#coverage" className="hover:text-[#D4AF37]">Markets</a></li>
                            <li><a href="#categories" className="hover:text-[#D4AF37]">Services</a></li>
                            <li><a href="#process" className="hover:text-[#D4AF37]">Our process</a></li>
                            <li><a href="#pricing" className="hover:text-[#D4AF37]">Pricing</a></li>
                            <li><a href="#playbook" className="hover:text-[#D4AF37]">Playbook</a></li>
                        </ul>
                    </div>
                    <div>
                        <div className="overline mb-4">Contact</div>
                        <ul className="space-y-2 text-sm text-white/60">
                            <li><a href="mailto:sales@leadkrafts.com" className="hover:text-[#D4AF37]">sales@leadkrafts.com</a></li>
                            <li><a href="tel:+917836874807" className="hover:text-[#D4AF37]">+91 78368 74807</a></li>
                            <li>Plot no. 20, Block H-1/A,<br />Sector 63, Noida,<br />Gautam Buddha Nagar — 201301<br />Uttar Pradesh, India</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="text-xs text-white/40">
                        © {new Date().getFullYear()} Lead Krafts. All rights reserved.
                    </div>
                    <div className="text-xs text-white/40 flex gap-6">
                        <a href="#" className="hover:text-[#D4AF37]">Privacy Policy</a>
                        <a href="#" className="hover:text-[#D4AF37]">Terms &amp; Conditions</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
